"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar2Pages = void 0;
var Navbar2Pages;
(function (Navbar2Pages) {
    Navbar2Pages["MARKETPLACE"] = "marketplace";
    Navbar2Pages["CREATE"] = "create";
    Navbar2Pages["EXPLORE"] = "explore";
    Navbar2Pages["LEARN"] = "learn";
    Navbar2Pages["GOVERNANCE"] = "governance";
})(Navbar2Pages = exports.Navbar2Pages || (exports.Navbar2Pages = {}));
